import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import nl from "./locales/nl.json";

export const SUPPORTED_LANGUAGES = ["en", "nl"] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_STORAGE_KEY = "primio-monitor-language";

export function isAppLanguage(value: string): value is AppLanguage {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

export function resolveAppLanguage(language: string): AppLanguage {
  const base = language.toLowerCase().split("-")[0];
  return isAppLanguage(base) ? base : "en";
}

/** BCP 47 tag for date/time formatting. */
export function toBcp47Locale(language: string): string {
  return resolveAppLanguage(language) === "nl" ? "nl-NL" : "en-GB";
}

function applyDocumentLanguage(language: string) {
  document.documentElement.lang = resolveAppLanguage(language);
}

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nl: { translation: nl },
    },
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
  })
  .then(() => {
    applyDocumentLanguage(i18next.resolvedLanguage ?? i18next.language);
  });

i18next.on("languageChanged", applyDocumentLanguage);

export default i18next;
